import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { DateTime } from 'luxon';

import CustomSelect from '../../Select/CustomSelect';
import Text from '../../Text/Text';
import CustomDatePicker from '../../CustomDatePicker/CustomDatePicker';
import getOrderStatistic from '../../../thunks/statistic/getOrderStatistic';
import { coOrderStatusList } from '../../../constants/coOrderStatus';

const defaultStatuses = ['New', 'Ready asb', 'Out of stock', 'Packed'];
const defaultSelection = coOrderStatusList.filter(({ value }) => defaultStatuses.includes(value));

const Actions = () => {
  const dispatch = useDispatch();
  const mounted = useRef(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedStatuses, setSelectedStatuses] = useState(defaultSelection);

  const dateParams = () => ({
    ...(startDate && { dateFrom: DateTime.fromJSDate(startDate).toISODate() }),
    ...(endDate && { dateTo: DateTime.fromJSDate(endDate).toISODate() })
  });

  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true;
      return;
    }
    if (startDate && !endDate) return;
    dispatch(getOrderStatistic({
      ...dateParams(),
      statuses: selectedStatuses.map(({ value }) => value)
    }));
  }, [startDate, endDate]);

  const onStatusesChange = (nextSelection) => {
    const next = nextSelection || [];
    setSelectedStatuses(next);
    dispatch(getOrderStatistic({
      ...dateParams(),
      statuses: next.map(({ value }) => value)
    }));
  };

  return (
    <div className="flex flex-col sm:flex-row gap-[15px] mb-[30px]">
      <div className="flex-1 min-w-0">
        <Text text="Status:" />
        <CustomSelect
          options={coOrderStatusList}
          value={selectedStatuses}
          placeholder="Select status"
          onChange={onStatusesChange}
          isMulti
        />
      </div>
      <div className="flex-1 min-w-0">
        <Text text="Range:" />
        <CustomDatePicker
          placeholderText="Select date range"
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
          maxDate={new Date()}
          monthsShown={2}
        />
      </div>
    </div>
  );
};

export default Actions;
